/* TODO: t() */
import React, { Component } from 'react';
import { View, Image, StyleSheet } from 'react-native';

import LoadingIndicator from '../uiold/LoadingIndicator';
import { Text, Link } from '../uiold';

import InvoiceConnect from './InvoiceConnect';
import { revokeAuth, setFreshbooksInvoiceSettings } from './freshbooks/helpers';

import { Account } from '../../types/shared/Account';

type Props = {
  account: Account;
};

type State = {
  isCheckingInvoiceSettings: boolean;
};

let FRESHBOOKS_URL = 'https://my.freshbooks.com';

class FreshbooksSettings extends Component<Props, State> {
  state: State = {
    isCheckingInvoiceSettings: false,
  };

  render() {
    let { account } = this.props;
    let { isCheckingInvoiceSettings } = this.state;

    let logoSrc =
      account.linked_accounts &&
      account.linked_accounts.freshbooks &&
      account.linked_accounts.freshbooks.invoice_settings &&
      account.linked_accounts.freshbooks.invoice_settings.presentation
        .image_logo_src
        ? account.linked_accounts.freshbooks.invoice_settings.presentation
            .image_logo_src
        : null;

    let logoPreview = logoSrc ? (
      <View>
        <Text>
          Current logo can be seen below.{' '}
          <Link onPress={this._setInvoiceSettings}>
            Click to re-fetch latest invoice settings
          </Link>
          .
        </Text>
        <Image
          style={styles.freshbooksInvoiceLogo}
          source={{ uri: FRESHBOOKS_URL + logoSrc }}
          resizeMode="contain"
          accessibilityLabel="Freshbooks Invoice Logo"
        />
      </View>
    ) : (
      <Text>
        No logo found.{' '}
        <Link onPress={this._setInvoiceSettings}>
          Click to fetch latest invoice settings
        </Link>
        .
      </Text>
    );

    return (
      <InvoiceConnect account={account} invoiceProvider="freshbooks">
        <View>
          <Text>
            Your Freshbooks account is connected.{' '}
            <Link onPress={revokeAuth}>Click here to disconnect</Link>.
          </Text>
          <Text>
            You need to set the logo and payment option in one of your recent
            Freshbooks invoices and then fetch the settings from here.
            MarketWurks will then include those settings in each new invoice
            created.
          </Text>
        </View>
        {isCheckingInvoiceSettings ? <LoadingIndicator /> : logoPreview}
      </InvoiceConnect>
    );
  }

  _setInvoiceSettings = () => {
    this.setState({ isCheckingInvoiceSettings: true });

    setFreshbooksInvoiceSettings(this._doneSetting);
  };

  _doneSetting = () => {
    this.setState({ isCheckingInvoiceSettings: false });
  };
}

let styles = StyleSheet.create({
  freshbooksInvoiceLogo: {
    width: 250,
    height: 250,
    borderWidth: 1,
  },
});

export default FreshbooksSettings;
